module.exports = __webpack_public_path__ + "opteo-example-73e450ec2a95afab76a64646507323fa.gif";